/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';

import type { OutstandingBalanceResponse } from './types';
import { apiClient } from '@/utils/apiClient';

export const fetchOutstandingBalance = createAsyncThunk<
  OutstandingBalanceResponse, // return type
  void, // no args
  { rejectValue: string }
>(
  'outstandingBalance/fetchOutstandingBalance',
  async (_, { rejectWithValue }) => {
    try {
      // Adjust path if your apiClient already includes payments_ms in the base URL
      const response = await apiClient('/payments/api/v1/status/', {
        method: 'GET',
      });

      return response as OutstandingBalanceResponse;
    } catch (err: any) {
      return rejectWithValue(
        err?.message || 'Failed to load outstanding balance'
      );
    }
  }
);
